import type { IsoDate } from './types';

const pacificCalendar = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles' });

/** Calendar day in California, independent of the device or Worker timezone. */
export const pacificToday = (now: Date): IsoDate => pacificCalendar.format(now);
